import Media from './Media';
import { MediaContext, IMediaContext } from './Media';

export default Media;
export { MediaContext, IMediaContext };
